import lang from "@/views/modules/ReviewerDocuments/language/en";
export default {
    name: "list-reviewer-documents",
    components: {
    },
    data() {
        return {
            page: 1,
            search: '',
            selectedOption: '',
            sort: {
                order: 'desc',
                column: 'date_entered',
                relRef: '',
            },
            perPage: 10,
            loading: true,
            series: 1,
            table_head: [
                {
                    label: lang.LBL_ITEM_NAME,
                    isSort: true,
                    relRef:'',
                    field_name: 'name'
                },
                {
                    label: lang.LBL_UPLOAD_DATE,
                    isSort: true,
                    relRef:'',
                    field_name: 'date_entered'
                },
                {
                    label: lang.LBL_APPLICATION_TITLE,
                    isSort: true,
                    relRef:'reviewerdocuments_applications',
                    field_name: 'application_title'
                },
                {
                    label: lang.LBL_OPPORTUNITY_TITLE,
                    isSort: false,
                    relRef:'',
                    field_name: 'opportunity_title'
                },
                {
                    label: lang.LBL_UPLOAD_BY,
                    isSort: true,
                    relRef:'reviewerdocuments_users',
                    field_name: 'created_by'
                }
            ],
            docList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang:[],
        }
    },
    mounted() {
        this.getReviewerDocument();
        this.lang = lang;
    },
    methods: {
        sortBy(field, relRef) {
            if (this.sort.column === field) {
                this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort.order = 'asc';
            }
            this.sort.column = field;
            this.sort.relRef = relRef;
           
            this.getReviewerDocument(this.search)
        },
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getReviewerDocument();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getReviewerDocument();
        },
        getReviewerDocument(search = '') {
            const self = this;
            self.loading = true;

            const storedFilters = localStorage.getItem('filters');
            
            if (storedFilters !== '') {
                self.search=storedFilters;
            }

            if (search != '') {
                self.search = search;
            }
            
             window.currentAction = 'list';
                axios.get('api/modules/reviewerdocuments', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.docList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getReviewerDocument();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },
        exportData() {
            const selectedValues = []
            this.records = {
                module: 'ReviewerDocuments',
                ids: selectedValues,
                callingFrom: 'export',
                all: this.selectedOption,
                search: this.search,
            }

            axios.post('api/export', this.records).then(function (response) {
                var link = document.createElement('a');
                link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data);
                link.download = 'data.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}